import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFrequencyModule } from '@vendasta/galaxy/frequency';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../assets/i18n/en_devel.json';
import { VaOrderFormModule } from '../order-form/order-form.module';
import { WEBLATE_COMPONENT_NAME } from '../shared/constants';
import { ContractEstimatedTotalComponent } from './contract-estimated-total/contract-estimated-total.component';
import { OrderSummarizedChargesComponent } from './order-summarized-charges/order-summarized-charges.component';
import { OrderSummarizedTotalsComponent } from './order-summarized-totals/order-summarized-totals.component';
import { OrderSummaryComponent } from './order-summary.component';
import { OrderSummaryService } from './order-summary.service';
import { BillingUiModule } from '@vendasta/billing-ui';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatExpansionModule,
    MatDividerModule,
    GalaxyFrequencyModule,
    GalaxyPipesModule,
    MatListModule,
    VaOrderFormModule,
    BillingUiModule,
  ],
  declarations: [
    OrderSummaryComponent,
    OrderSummarizedTotalsComponent,
    OrderSummarizedChargesComponent,
    ContractEstimatedTotalComponent,
  ],
  exports: [
    OrderSummaryComponent,
    OrderSummarizedTotalsComponent,
    OrderSummarizedChargesComponent,
    ContractEstimatedTotalComponent,
  ],
  providers: [OrderSummaryService],
})
export class VaOrderSummaryModule {}
